// FTEDN Creator — Gamified Sidebar
import { useAuth } from '../../hooks/useAuth';
import { XPBar } from '../gamification/XPBar';
import './Sidebar.css';

const NAV_ITEMS = [
  { icon: '🏠', label: 'Dashboard', path: '/dashboard', badge: 0 },
  { icon: '🧪', label: 'Beta Lab', path: '/beta', badge: 2 },
  { icon: '🔬', label: 'Product Lab', path: '/lab', badge: 0 },
  { icon: '🗳️', label: 'Vote & Create', path: '/vote', badge: 4 },
  { icon: '💬', label: 'Community', path: '/community', badge: 3 },
  { icon: '🔔', label: 'Alerts', path: '/alerts', badge: 2 },
];

export function Sidebar() {
  const { displayName, logout } = useAuth();
  const currentPath = window.location.pathname;

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <span className="sidebar-logo"><span className="logo-f">f</span><span className="logo-dot">.</span></span>
        <span className="sidebar-app-label">creator</span>
      </div>

      {/* Mini XP bar */}
      <div className="sidebar-xp">
        <XPBar currentXP={1750} maxXP={3000} level={7} tierName="Sprout" compact />
      </div>

      <nav className="sidebar-nav">
        {NAV_ITEMS.map((item) => (
          <a key={item.path} href={item.path}
            className={`sidebar-link ${currentPath === item.path ? 'active' : ''}`}>
            <span className="sidebar-link-icon">{item.icon}</span>
            <span className="sidebar-link-label">{item.label}</span>
            {item.badge > 0 && (
              <span className="sidebar-badge">{item.badge}</span>
            )}
            {currentPath === item.path && <div className="sidebar-active-glow" />}
          </a>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">
            <span className="sidebar-avatar-letter">{displayName.charAt(0)}</span>
            <div className="sidebar-avatar-ring" />
          </div>
          <div className="sidebar-user-info">
            <span className="sidebar-username">{displayName}</span>
            <span className="sidebar-tier">🌱 Sprout · Lv.7</span>
          </div>
        </div>
        <button className="sidebar-logout" onClick={logout} id="logout-btn">
          ← Sign Out
        </button>
      </div>
    </aside>
  );
}
